export const DESIGN_PALETTE = [
  "#e6f7ff",
  "#fff0f6",
  "#f9f0ff",
  "#f6ffed",
  "#fffbe6",
  "#f0f5ff",
  "#e8f5e9",
  "#fffde7",
  "#fce4ec",
  "#ede7f6",
];

export function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function colorForDesign(designName, palette = DESIGN_PALETTE) {
  const key = (designName || "UNKNOWN").trim();
  const idx = hashString(key) % palette.length;
  return palette[idx];
}

export const STATUS_CHIP_COLORS = {
  Created: "#1976d2",
  Offered: "#ed6c02",
  Cancelled: "#d32f2f",
  Accepted: "#00796b",
};

export const STATUS_CHIP_WIDTH = 92;
export const STATUS_DATE_CHIP_WIDTH = 104;

export function designChipSx(bgHex, theme) {
  if (!bgHex) return {};
  const isDark = theme?.palette?.mode === "dark";
  return {
    height: 24,
    maxWidth: "100%",
    fontWeight: 800,
    fontSize: "0.68rem",
    letterSpacing: 0.1,
    bgcolor: isDark ? `${bgHex}55` : bgHex,
    color: isDark ? theme.palette.common.white : "#1e293b",
    border: "1px solid",
    borderColor: isDark ? `${bgHex}99` : "rgba(15, 23, 42, 0.12)",
    boxShadow: isDark ? "none" : `0 6px 16px ${bgHex}66`,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}

export function statusChipSx(status, theme, alphaFn) {
  const color =
    STATUS_CHIP_COLORS[status] || theme?.palette?.text?.secondary || "#64748b";
  const alpha = alphaFn || ((c, v) => c);
  return {
    height: 22,
    width: STATUS_CHIP_WIDTH,
    minWidth: STATUS_CHIP_WIDTH,
    maxWidth: STATUS_CHIP_WIDTH,
    justifyContent: "center",
    fontWeight: 800,
    fontSize: "0.66rem",
    bgcolor: alpha(color, 0.12),
    color,
    border: "1px solid",
    borderColor: alpha(color, 0.28),
    "& .MuiChip-label": {
      px: 0.5,
      width: "100%",
      textAlign: "center",
    },
  };
}

export function statusDateChipSx(theme, alphaFn) {
  const alpha = alphaFn || ((c, v) => c);
  return {
    height: 22,
    width: STATUS_DATE_CHIP_WIDTH,
    minWidth: STATUS_DATE_CHIP_WIDTH,
    maxWidth: STATUS_DATE_CHIP_WIDTH,
    justifyContent: "center",
    fontWeight: 600,
    fontSize: "0.66rem",
    bgcolor: alpha(theme.palette.text.primary, 0.04),
    color: theme.palette.text.secondary,
    border: "1px solid",
    borderColor: alpha(theme.palette.divider, 0.85),
    "& .MuiChip-label": {
      px: 0.5,
      width: "100%",
      textAlign: "center",
    },
  };
}

export function treeGroupChipSx(depth, theme, alphaFn, label = "") {
  const alpha = alphaFn || ((c, v) => c);

  // Temporada (depth 0): color por nombre, sin pintar toda la fila
  const seasonPalettes = [
    { base: "#ff9800" },
    { base: "#43a047" },
    { base: "#1e88e5" },
    { base: "#8e24aa" },
    { base: "#f9a825" },
    { base: "#e53935" },
    { base: "#00897b" },
    { base: "#00acc1" },
  ];

  let preset;
  if (depth === 0) {
    const name = String(label || "");
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
    }
    const { base } = seasonPalettes[Math.abs(hash) % seasonPalettes.length];
    preset = {
      bgcolor: alpha(base, 0.16),
      color: base,
      borderColor: alpha(base, 0.32),
    };
  } else {
    const depthPresets = [
      {
        bgcolor: alpha("#ff9800", 0.14),
        color: "#e65100",
        borderColor: alpha("#ff9800", 0.28),
      },
      {
        bgcolor: alpha("#00bfa5", 0.12),
        color: "#00796b",
        borderColor: alpha("#00bfa5", 0.28),
      },
      {
        bgcolor: alpha("#f9620f", 0.12),
        color: "#e65100",
        borderColor: alpha("#f9620f", 0.28),
      },
    ];
    preset = depthPresets[depth] || depthPresets[depthPresets.length - 1];
  }

  return {
    height: 24,
    maxWidth: "100%",
    fontWeight: depth === 0 ? 800 : 700,
    fontSize: "0.7rem",
    bgcolor: preset.bgcolor,
    color: preset.color,
    border: "1px solid",
    borderColor: preset.borderColor,
    "& .MuiChip-label": {
      px: 0.85,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };
}
